export enum HistoryToggleOptions {
  All_History,
  Comments_Only
}
